import { forwardRef } from "react";
function SvgArrowLineRight({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={173}
      height={72}
      viewBox="0 0 173 72"
      preserveAspectRatio="none"
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        d="M163 13.5C163 6.044 156.956 0 149.5 0H1.5a1.5 1.5 0 1 0 0 3h148c5.799 0 10.5 4.701 10.5 10.5v53.379l-6.985-6.985a1.5 1.5 0 1 0-2.121 2.12l9.546 9.547a1.5 1.5 0 0 0 2.121 0l9.546-9.546a1.501 1.501 0 0 0-2.122-2.121L163 66.879V13.5Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgArrowLineRight);
export default ForwardRef;
